import { h } from '@stencil/core';

export const iconOptions = ['ArrowRight'] as const;
export type IconOptions = (typeof iconOptions)[number];

export const ArrowRight = ({ width, height }) => (
  <svg style={{ height: height, width: width }} width={width} height={height} viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <rect width={width} height={height} fill="white" fill-opacity="0.01"></rect>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.03711 18.1552L14.1736 12.0187L8.03711 5.88229L9.91561 4.00378L17.9306 12.0187L9.91561 20.0337L8.03711 18.1552Z"></path>
  </svg>
);
